import { useState, useRef, useEffect, useCallback } from "react";
import { toastr } from "react-redux-toastr";
import { client, getApiErrorMessage } from "utils/api";

const StartWorkflow = ({
  type,
  id,
  refetch,
  refetchStatuses,
  is_mass_event_enabled,
  mass_events,
  setMassEvents,
}) => {
  const ref = useRef();
  const [is_open, setOpen] = useState(false);
  const [is_loading, setLoading] = useState(false);

  const startWorkflow = async ({ type, id }) => {
    try {
      setLoading(true);

      await client.post(`/channel_product_workflows/start_workflows`, {
        type,
        id,
      });
      await refetch();
      refetchStatuses();
      toastr.success("Sukces", "Zaktualizowano");
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSetMassEvent = useCallback(
    ({ checked, uniq_id, id, type }) => {
      if (checked) {
        const _mass_events = [
          ...mass_events,
          {
            action: "start_workflows",
            uniq_id,
            id,
            type,
          },
        ];
        setMassEvents(_mass_events);
      } else {
        const _mass_events = [...mass_events].filter(
          (item) => item.uniq_id !== uniq_id,
        );
        setMassEvents(_mass_events);
      }
    },
    [mass_events, setMassEvents],
  );

  const uniq_id = [type?.toLowerCase(), id, "start_workflows"].join("_");
  const is_checked = mass_events.findIndex((a) => a.uniq_id === uniq_id) > -1;

  return (
    <div className="single-box">
      {is_mass_event_enabled ? (
        <div onClick={(e) => e.stopPropagation()}>
          <div
            key={uniq_id}
            className={`event-check ${is_checked ? "active" : ""}`}
          >
            <input
              type="checkbox"
              id={uniq_id}
              onChange={({ target: { checked } }) =>
                handleSetMassEvent({ checked, uniq_id, type, id })
              }
              checked={is_checked}
            />
            <label htmlFor={uniq_id}>Rozpocznij</label>
          </div>
        </div>
      ) : (
        <div className={`event-select info ${is_open ? "open" : ""}`} ref={ref}>
          <button
            className="event-select__trigger"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpen(!is_open);
            }}
          >
            <span className="status-box">Oczekuje</span>
            <svg
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="none"
                d="M9 1L5 5L1 1"
                stroke="#192027"
                strokeLinecap="round"
                strokeWidth="2"
              />
            </svg>
          </button>
          <ul className="event-select__options">
            <li>
              <button
                disabled={is_loading}
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  startWorkflow({
                    type,
                    id,
                  });
                }}
              >
                {is_loading ? "Proszę czekać..." : "Rozpocznij"}
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default StartWorkflow;
